module.exports = __webpack_public_path__ + "img/class4.c8667aa9.png";